// extracted by mini-css-extract-plugin
export default {"task-status-wrapper":"task-status-wrapper--mLBos"};